import React from 'react';
import styled from 'styled-components';

interface OfferMessageTabNavProps {
  mainTab: string;
  setMainTab: (value: React.SetStateAction<string>) => void;
}

function OfferMessageTabNav({ mainTab, setMainTab }: OfferMessageTabNavProps) {
  return (
    <div className="row">
      <div className="col-md-4">
        <StyledNavButtonsContainer>
          <label
            className={
              mainTab === 'sendNewMessage'
                ? 'btn btn-info active'
                : 'btn btn-default'
            }
            onClick={() => {
              setMainTab('sendNewMessage');
            }}
            data-cy="main-tab-send-new-message"
          >
            <i className="fa fa-bullhorn"></i> Send New Message
          </label>
          <label
            className={
              mainTab === 'sentMessage'
                ? 'btn btn-info active'
                : 'btn btn-default'
            }
            onClick={() => {
              setMainTab('sentMessage');
            }}
            data-cy="main-tab-sent-messages"
          >
            <i className="fa fa-paper-plane"></i> Sent Messages
          </label>
        </StyledNavButtonsContainer>
      </div>
    </div>
  );
}

export default OfferMessageTabNav;

const StyledNavButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;

  .btn {
    border-radius: 0;
  }

  .btn-info:hover {
    background-color: #4ea5e0;
    border-color: #4ea5e0;
    color: #ffffff;
  }

  .btn-default {
    background-color: #fff;
    color: #4ea5e0;
    border-color: #4ea5e0;

    &:hover {
      background-color: #fff;
      color: #4ea5e0;
      border-color: #4ea5e0;
    }
  }
`;
